export default __webpack_public_path__ + "static/media/cny-flower.fa6b9a86.png";